import { useQueryClient } from "@tanstack/react-query";
import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { UsuarioSessaoCliente } from "@/hooks/use-sessao";
import { apiFetch } from "@/lib/api";

interface TopbarProps {
  user: UsuarioSessaoCliente;
}

export function Topbar({ user }: TopbarProps) {
  const navigate = useNavigate();
  const qc = useQueryClient();

  async function sair() {
    try {
      await apiFetch("/api/auth/sign-out", { method: "POST" });
    } catch {
      /* mesmo se falhar, limpa estado local */
    }
    qc.removeQueries({ queryKey: ["sessao"] });
    toast.success("Sessão encerrada");
    navigate("/login", { replace: true });
  }

  const iniciais = (user.name ?? user.email).slice(0, 2).toUpperCase();
  const nomeExibicao = user.name ?? user.email.split("@")[0];

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center justify-end border-b border-border bg-background/80 px-6 backdrop-blur">
      <DropdownMenu>
        <DropdownMenuTrigger className="flex items-center gap-3 rounded-full pl-2 pr-3 py-1 text-sm transition-colors hover:bg-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-ring">
          <span className="flex size-8 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary">
            {iniciais}
          </span>
          <span className="hidden text-left sm:block">
            <span className="block text-sm font-medium leading-tight">{nomeExibicao}</span>
            <span className="block text-xs text-muted-foreground">{user.perfil}</span>
          </span>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel>{user.email}</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onSelect={sair}>
            <LogOut className="size-4" />
            Sair
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  );
}
